<template>
  <v-container class="pa-0" id="maincontainer" >


        <v-overlay v-model="overlay"
            :color= "businesses.themecolor!=null?businesses.themecolor:'#FE5800'"
        >
            <v-progress-circular indeterminate size="64"></v-progress-circular>


          </v-overlay>

          <v-overlay v-model="overlayPIN" >
            <!-- <v-progress-circular indeterminate size="64"></v-progress-circular> -->
            <img :src="cocacolaImg" style="max-height:250px;max-width:auto !important;display:inline !important;" />
          </v-overlay>
          <LanguageSelector v-if="countActivelang==1 && showlanguageselector && userlangcode==''" :business='businesses' v-on:set-user-language="onSetUserLanguage" />
          <router-view v-if="countActivelang==0 || !showlanguageselector" :countActivelang='countActivelang' :order='currentorder' :fooditem='currentfooditemdata' :business='businesses' :isloaded='!loading'  :event='currentEventdata' :employee='currentTeamdata' :tag='tag'  >

        </router-view>

        <!-- <businessDetails :business='businesses' v-if="currentSection=='overview' && !loading"/>
        <events :business='businesses' v-if="currentSection=='event' && !loading" />
        <teams :business='businesses' v-if="currentSection=='team' && !loading"/>
        <businesslove :business='businesses' v-if="currentSection=='love' && !loading"/> -->
        <v-bottom-navigation
          :value="activeBtn"
          grow
          :background-color= "businesses.themecolor!=null?businesses.themecolor:'#FE5800'"

          color="#fff"
          fixed
          v-if="!showlanguageselector" 
         >

         <!-- <v-bottom-navigation
          :value="activeBtn"
          grow
          :background-color= "businesses.themecolor!=null?businesses.themecolor:'#FE5800'"

          color="#fff"
          fixed
          
         > -->

            <v-btn  @click="home">
                <span>{{hometitle}}</span>
                <v-icon>{{homeicon}}</v-icon>
            </v-btn>

            <v-btn @click="event" v-show="businesses.showevent==1">
                    <span>Events</span>
                    <v-icon>mdi-calendar</v-icon>
            </v-btn>

            <!-- <v-btn @click="food" v-if="showfood==1">
                    <span>Food</span>
                    <v-icon>mdi-food</v-icon>
            </v-btn>

            <v-btn @click="home" target="_blank"  >
                <img :src="logoImg" class="" height="60"/>
            </v-btn>-->

            <v-btn @click="team" v-show="businesses.showteam==1">
                <span>{{teamtitle}}</span>
                <v-icon>{{teamicon}}</v-icon>
            </v-btn>

            <v-btn @click="love" v-show="businesses.showlove==1">
                <span >{{lovetitle}}</span>
                <v-icon>{{loveicon}}</v-icon>
            </v-btn>
            <!-- <v-btn @click="home"   >

                <img :src="logoImg" class="" height="60"/>
            </v-btn> -->


            <!--  <v-btn  dark @click="waiterdialog=!waiterdialog">
                <img :src="logoImg"  class="" height="60"/>
              </v-btn> -->




            <v-btn  @click="food" v-show="businesses.showfood==1">
                <span>{{foodtitle}}</span>
                <v-icon>{{foodicon}}</v-icon>
            </v-btn>

            <v-btn @click="drink" v-show="businesses.showdrink==1">
                    <span>{{drinktitle}}</span>
                    <v-icon>{{drinkicon}}</v-icon>
            </v-btn>

            <v-btn @click="retailitem" v-show="businesses.showretail==1">
                    <span>{{retailtitle}}</span>
                    <v-icon>{{retailicon}}</v-icon>
            </v-btn>



            <!-- <v-btn @click="event">
                    <span>{{eventtitle}}</span>
                    <v-icon>mdi-coktaile</v-icon>
            </v-btn>

            <v-btn @click="health" target="_blank"  >

                <span></span>
                <v-icon>mdi-medical-bag</v-icon>
            </v-btn>

            <v-btn @click="team" >
                <span>{{teamtitle}}</span>
                <v-icon>{{teamicon}}</v-icon>
            </v-btn>

            <v-btn @click="love" >
                <span >{{lovetitle}}</span>
                <v-icon>{{loveicon}}</v-icon>
            </v-btn> -->
        </v-bottom-navigation>

          <v-dialog v-model="waiterdialog" fullscreen hide-overlay transition="dialog-bottom-transition">
              <!-- <template v-slot:activator="{ on }">
                <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
              </template> -->
              <v-card class="" elevation=0>



                <v-card-text>
                    <v-row>
                      <v-col v-if="businesses.logo==''" cols="12"  class="text-center  mb-5" style="font-size:30px;margin-top:60px;">
                      {{businesses.businessName}}
                      </v-col>
                      <v-col v-else cols="12"  class="text-center  mb-5" style="font-size:30px;margin-top:60px;">
                      <img :src="businesses.logo" height="50" />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" class="text-center" >
                        <div style="text-align:center;width:100%;padding:12px;border:2px solid #FE5800;font-size:30px" >
                        {{businesses.businesscode}}
                      </div>

                      </v-col>
                    </v-row>
                </v-card-text>


                <v-card-text class="mt-5">
                    <v-row class="mb-5">
                      <v-col cols="12" style="font-size:40px;color:#ff5722" class="text-center">
                        juZZap.com
                      </v-col>
                    </v-row>


                    <v-row class="mt-3">
                      <v-col cols="12" class="text-center">
                          <img width="200" :src="'data:image/png;base64,'+ businesses.qrimage ">

                      </v-col>
                    </v-row>
                    <v-row class="mt-3 mb-3">

                          <v-col cols="12" class="text-center ">
                              powered by juZZap
                          </v-col>
                      </v-row>
                        <p class="mb-12 pb-12"></p>

                </v-card-text>

              </v-card>
              <v-footer
                fixed
                class="font-weight-medium"
                color="transparent">
                <v-col
                  class="text-center"
                  cols="12">
                  <v-btn @click="waiterdialog=false" fab small color="#fe5800" >
                    <v-icon class="white--text">mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-footer>

          </v-dialog>



  </v-container>
</template>
<script>
import Vue from 'vue'
import businessDetails from '@/components/businessDetails.vue';
import LanguageSelector from '@/components/LanguageSelector.vue';
// import events from '@/components/events.vue';
// import teams from '@/components/teams.vue';
// import businesslove from '@/components/businesslove.vue';

import { EventBus } from '@/event-bus';
//import Tags from '@/components/TagsNew.vue';

export default Vue.extend({
    data: () =>
    ({

      cocacolaImg:require('@/assets/cocacola2.gif'),

      overlay: false,
      overlayPIN:false,
      waiterdialog: false,
      notifications: false,
      sound: true,
      widgets: false,


      logoImg:require('@/assets/zzlogo.png'),



      bannerImg:require('@/assets/restaurant1.svg'),

      logo:require('@/assets/logo.png'),

      loading:true,

      longdesc:false,
      tag:'',
      business_id: 0,
      businesses: [],
      code:0,
      starrating:0,
      activeBtn: 0,
      shortdesc:'',
      facilitiy:[],
      facilities_id:"",
      facilities:[{'id':'','facility':'','link':'','description':''}],
      bgallery:[],
      dialog: false,
      facilityDesc:'',
      facilitiyTitle:'',
      currentSection:'overview',
      currentEvent:0,
      currentTeam:0,
      currentfooditem:0,
      currentcourseid:0,
      currentEventdata:[],
      currentTeamdata:[],
      currentfooditemdata:[],
      eventprices:[],
      eventgallery:[],
      currencyicon:'',
      currentorder:{'ordertype':'','name':'','phone':'','address':'','items':[]},
      eventbannerImg:'',
      offsetTop:0,
      showevent:0,
      showteam:0,
      showlove:0,
      showfood:0,

      homeicon:'',
      hometitle:'',
      eventicon:'',
      eventtitle:'',
      teamicon:'',
      teamtitle:'',
      loveicon:'',
      lovetitle:'',
      foodtitle:'',
      foodicon:'',
      drinktitle:'',
      drinkicon:'',
      retailtitle:'',
      retailicon:'',
      businesslanguages:[],
      showlanguageselector:0,
      userlangcode:'',
      countActivelang:0,
  }),
    components:{
        businessDetails,
        LanguageSelector
        // events,
        // teams,
        // businesslove,
    },
    created()
    {







        if (this.$route.name=='food')
        {

            this.food();
            var th=this;


        }
        if (this.$route.name=='order')
        {

            this.order();
            var th=this;


        }
        if (this.$route.params.eventid)
        {
            this.currentEvent = this.$route.params.eventid;
            this.eventdetails();
            var th=this;
        }
        if (this.$route.params.fooditemid && this.$route.params.courseid)
        {
            this.currentfooditem = this.$route.params.fooditemid;
            this.currentcourseid=this.$route.params.courseid;
            this.fooditemdetails();
            var th=this;
        }



        if (this.$route.params.teamid)
        {
            this.currentTeam = this.$route.params.teamid;
            this.teamdetail();
            var th=this;


        }

        this.getBusiness();

        // this.countactivelang();

        // window.addEventListener('scroll', this.onScroll);
        //this.food();
    },
    destroyed () {
    //window.removeEventListener('scroll', this.onScroll);
  },
    mounted(){

      //  console.log('mounted');

        if (this.$route.params.tag)
        {
          this.tag = this.$route.params.tag;
         // this.getBusiness();

      //    console.log('route name '+this.$route.name);

          if(this.$route.name=='events')
          {
            //this.getBusiness();
            this.activeBtn=1;
          }
          else if(this.$route.name=='team')
          {
            //this.getBusiness();
            this.activeBtn=2;
          }
          else if(this.$route.name=='love')
          {
            //this.getBusiness();
            this.activeBtn=3;
          }
          else if(this.$route.name=='food')
          {
            //this.getBusiness();
            this.activeBtn=4;
          }
          else if(this.$route.name=='drink')
          {
            console.log('tag IN'+this.$route.name);

            //this.getBusinessDrink();
            this.activeBtn=5;

          }
          else if(this.$route.name=='retailitem')
          {
            this.activeBtn=6;
          }

          else
          {
            //this.getBusiness();
            this.activeBtn=0;

          }

          //this.getBusiness();

          var th=this;


        }


        EventBus.$on('eventclick', eventid =>{
                this.currentEvent=eventid
                this.eventdetails();
            });

        EventBus.$on('fooditemclick', fooditem =>{
                this.currentfooditem=fooditem.fooditemid;
                this.currentcourseid=fooditem.courseid;
                this.fooditemdetails();
            });


        EventBus.$on('teamclick', teamid =>{
                this.currentTeam=teamid
                this.teamdetail();
            });

        EventBus.$on('healthadvicedetail',eventid =>{
                this.currentEvent=eventid
                this.healthadvicedetail();
            });

        this.getBusiness();
        // this.countactivelang();

  
    },
    watch:{
        activeBtn:function(value)
        {
            return value;
        },
        currentEvent:function(value)
        {
            return value;
        },
        currentEventdata:function(value)
        {
            return value;
        },
        currentfooditem:function(value)
        {
            return value;
        },
        currentfooditemdata:function(value)
        {
            return value;
        },
        currentTeam:function(value)
        {
            return value;
        },
        currentTeamdata:function(value)
        {
            return value;
        },
        order:function(value)
        {
            return value;
        },
        loading:function(value)
        {
            return value;
        }
    },

    methods:{
      onSetUserLanguage(langcode) {
        localStorage.setItem('langcode-'+this.businesses.id,langcode);

        this.userlangcode=langcode;
        this.showlanguageselector =0;
  },
      getCookie(cname)
      {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++)
        {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      },
      setCookie(cname, cvalue, exdays)
      {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      },

      getBusinessDrink()
      {
          this.$http
          .get(this.$apidomain+"checkbusinesssponsored/" + this.tag)
          .then(res =>
          {
            if (res.data.sponsored == 1 && res.data.success == 1)
            {
                //this.$router.push({name:'businesshome',params:{code: this.businesscode.trim(),type:'uc',key:this.getCookie('jzuserkey')}});
                //this.$router.push({name:'bDetails',params:{tag:  this.businesscode,key:this.getCookie('jzuserkey')}});
                //Again call this api for loader cocacola
                this.overlayPIN=true;
            }
            else if(res.data.sponsored == 0 && res.data.success == 1)
            {
              this.overlay=true;

            }
          })
          .catch(err =>
          {
            this.overlayPIN=false;
            this.overlay=true;
            console.log(err.response);
          });

            console.log('ENC CALL ');


        let url=this.$apidomain+"businessdatanewdrink/" + this.tag;

        if(this.getCookie('jzuserkey')!='')
        {
          url=this.$apidomain+"businessdatanewdrink/" + this.tag+'/'+this.getCookie('jzuserkey');
        }

        this.$http
        .get(url)
        .then(res => {
            console.log('bus '+res.data.business)
           // this.businesses =res.data.business;

            if(this.businesses.homeicon==null || this.businesses.homeicon=='null')
            {
              this.homeicon='mdi-home';

            }else{
              this.homeicon=this.businesses.homeicon;
            }

            if(this.businesses.hometitle==null || this.businesses.hometitle=='null')
            {
              this.hometitle='Home';

            }else{
              this.hometitle=this.businesses.hometitle;
            }

            if(this.businesses.foodtitle==null || this.businesses.foodtitle=='null')
            {
              this.foodtitle='Food Menu';

            }else{
              this.foodtitle=this.businesses.foodtitle;
            }

            if(this.businesses.foodicon==null || this.businesses.foodicon=='null')
            {
              this.foodicon='mdi-food';

            }else{
              this.foodicon=this.businesses.foodicon;
            }

            if(this.businesses.drinktitle==null || this.businesses.drinktitle=='null')
            {
              this.drinktitle='Drink Menu';

            }else{
              this.drinktitle=this.businesses.drinktitle;
            }

            if(this.businesses.drinkicon==null || this.businesses.drinkicon=='null')
            {
              this.drinkicon='mdi-glass-cocktail';

            }else{
              this.drinkicon=this.businesses.drinkicon;
            }

            if(this.businesses.retailtitle==null || this.businesses.retailtitle=='null')
            {
              this.retailtitle='Retail';

            }else{
              this.retailtitle=this.businesses.retailtitle;
            }

            if(this.businesses.retailicon==null || this.businesses.retailicon=='null')
            {
              this.retailicon='mdi-cart';

            }else{
              this.retailicon=this.businesses.retailicon;
            }

            if(this.businesses.loveicon==null || this.businesses.loveicon=='null')
            {
              this.loveicon='mdi-share-variant';

            }else{
              this.loveicon=this.businesses.loveicon;
            }

            if( this.businesses.lovetitle==null || this.businesses.lovetitle=='null')
            {
              this.lovetitle='Love';

            }else{
              this.lovetitle=this.businesses.lovetitle;
            }



            // if(localStorage.getItem('drinkorder-'+this.businesses.id))
            // {
            //   console.log('drinkorder-'+this.businesses.id)

            //   this.currentorder=JSON.parse(localStorage.getItem('drinkorder-'+this.businesses.id));
            //   //alert(this.currentorder.items)
            // }else
            // {
            //   localStorage.setItem('drinkorder-'+this.businesses.id,JSON.stringify({'items':[]}));
            //   this.currentorder=JSON.parse(localStorage.getItem('drinkorder-'+this.businesses.id));
            // }
            console.log('call order item')
            if(localStorage.getItem('order-'+this.businesses.id))
            {
              console.log('order-'+this.businesses.id)
              let corder=JSON.parse(localStorage.getItem('order-'+this.businesses.id));
              this.currentorder.items=corder.items;
              this.currentorder.name=corder.name?corder.name:'';
              this.currentorder.phone=corder.phone?corder.phone:'';
              this.currentorder.address=corder.address?corder.address:'';
              this.currentorder.ordertype=corder.ordertype?corder.ordertype:'';
            // this.currentorder=JSON.parse(localStorage.getItem('order-'+this.businesses.id));
              //alert(this.currentorder.items)
            }else
            {
              localStorage.setItem('order-'+this.businesses.id,JSON.stringify({'ordertype':'','name':'','phone':'','address':'','items':[]}));
              this.currentorder=JSON.parse(localStorage.getItem('order-'+this.businesses.id));
            }


            this.overlay=false;
            this.overlayPIN=false;

            this.loading=false;
          })
          .catch(err => {
            console.log('ERROR ');

            console.log(err.response);
          });


      },
      countactivelangbusiness()
      {
          this.$http
          .get(this.$apidomain+"checklangactive/" + this.businesses.id)
          .then(res =>
          {
            if (res.data.avtivelang == 1 )
            {
                //this.$router.push({name:'businesshome',params:{code: this.businesscode.trim(),type:'uc',key:this.getCookie('jzuserkey')}});
                //this.$router.push({name:'bDetails',params:{tag:  this.businesscode,key:this.getCookie('jzuserkey')}});
                //Again call this api for loader cocacola
                this.countActivelang=1;
            }
            else if(res.data.avtivelang == 0 )
            {
              this.countActivelang=0;

            }
          })
          .catch(err =>
          {
            this.overlayPIN=false;
            this.overlay=true;


            //console.log(err.response);
          });
      },

      getBusiness()
      {


        
        
        this.$http
        .get(this.$apidomain+"checkbusinesssponsored/" + this.tag)
        .then(res =>
        {
          if (res.data.sponsored == 1 && res.data.success == 1)
          {
              //this.$router.push({name:'businesshome',params:{code: this.businesscode.trim(),type:'uc',key:this.getCookie('jzuserkey')}});
              //this.$router.push({name:'bDetails',params:{tag:  this.businesscode,key:this.getCookie('jzuserkey')}});
              //Again call this api for loader cocacola
              this.overlayPIN=true;
          }
          else if(res.data.sponsored == 0 && res.data.success == 1)
          {
            this.overlay=true;

          }
        })
        .catch(err =>
        {
          this.overlayPIN=false;
          this.overlay=true;


          //console.log(err.response);
        });
        let url='';
      if(this.getCookie('jzuserkey')!='')
        {
          url=this.$apidomain+"businessdatanew/" + this.tag+'/'+this.getCookie('jzuserkey');
        }else{
          url=this.$apidomain+"businessdatanew/" + this.tag;
        }

        this.$http
        .get(url)
        .then(res => {
              this.businesses =res.data.business;

              this.countactivelangbusiness();

              if(res.data.business.hastranslations ){



                this.userlangcode=localStorage.getItem('langcode-'+this.businesses.id);

                if(!this.userlangcode)
                {
                  this.userlangcode="";
                  this.showlanguageselector=1;

                }
              }else
              {
                this.showlanguageselector=0;

              }





            this.$vuetify.theme.themes.light.primary = this.businesses.themecolor;
          if(localStorage.getItem('order-'+this.businesses.id)){
            console.log('order-'+this.businesses.id)
              let corder=JSON.parse(localStorage.getItem('order-'+this.businesses.id));
              this.currentorder.items=corder.items;
              this.currentorder.name=corder.name?corder.name:'';
              this.currentorder.phone=corder.phone?corder.phone:'';
              this.currentorder.address=corder.address?corder.address:'';
              this.currentorder.ordertype=corder.ordertype?corder.ordertype:'';
            // this.currentorder=JSON.parse(localStorage.getItem('order-'+this.businesses.id));
              console.log(this.currentorder.items)
            }else{
              localStorage.setItem('order-'+this.businesses.id,JSON.stringify({'ordertype':'','name':'','phone':'','address':'','items':[]}));
              this.currentorder=JSON.parse(localStorage.getItem('order-'+this.businesses.id));
            }
            this.setCookie('jzuserkey',this.businesses.notloggedinkey,30);
            if(this.businesses.languagecode=='en'||this.businesses.languagecode=='es'){
              this.$i18n.locale=this.businesses.languagecode;
            }

            this.showevent=this.businesses.showevent;
            this.showteam=this.businesses.showteam;
            this.showlove=this.businesses.showlove;
            this.showfood=this.businesses.showfood;

            if(this.businesses.homeicon==null || this.businesses.homeicon=='null')
            {
              this.homeicon='mdi-home';

            }else{
              this.homeicon=this.businesses.homeicon;
            }

            if(this.businesses.hometitle==null || this.businesses.hometitle=='null')
            {
              this.hometitle='Home';

            }else{
              this.hometitle=this.businesses.hometitle;
            }

            if(this.businesses.drinktitle==null || this.businesses.drinktitle=='null')
            {
              this.drinktitle='Drink Menu';

            }else{
              this.drinktitle=this.businesses.drinktitle;
            }

            if(this.businesses.drinkicon==null || this.businesses.drinkicon=='null')
            {
              this.drinkicon='mdi-glass-cocktail';

            }else{
              this.drinkicon=this.businesses.drinkicon;
            }

            if(this.businesses.retailtitle==null || this.businesses.retailtitle=='null')
            {
              this.retailtitle='Retail';

            }else{
              this.retailtitle=this.businesses.retailtitle;
            }

            if(this.businesses.retailicon==null || this.businesses.retailicon=='null')
            {
              this.retailicon='mdi-cart';

            }else{
              this.retailicon=this.businesses.retailicon;
            }

            if(this.businesses.foodtitle==null || this.businesses.foodtitle=='null')
            {
              this.foodtitle='Food Menu';

            }else{
              this.foodtitle=this.businesses.foodtitle;
            }

            if(this.businesses.foodicon==null || this.businesses.foodicon=='null')
            {
              this.foodicon='mdi-food';

            }else{
              this.foodicon=this.businesses.foodicon;
            }


            if(this.businesses.eventicon==null || this.businesses.eventicon=='null')
            {
              this.eventicon='mdi-calendar';

            }else{
              this.eventicon=this.businesses.eventicon;
            }




            if(this.businesses.eventtitle==null || this.businesses.eventtitle=='null')
            {
              this.eventtitle='Event';

            }else{
              this.eventtitle=this.businesses.eventtitle;
            }

            if(this.businesses.teamicon==null || this.businesses.teamicon=='null')
            {
              this.teamicon='mdi-account-multiple';

            }else{
              this.teamicon=this.businesses.teamicon;
            }

            if(this.businesses.teamtitle==null || this.businesses.teamtitle=='null')
            {
              this.teamtitle='Team';

            }else{
              this.teamtitle=this.businesses.teamtitle;
            }


            if(this.businesses.loveicon==null || this.businesses.loveicon=='null')
            {
              this.loveicon='mdi-share-variant';

            }else{
              this.loveicon=this.businesses.loveicon;
            }

            if( this.businesses.lovetitle==null || this.businesses.lovetitle=='null')
            {
              this.lovetitle='Love';

            }else{
              this.lovetitle=this.businesses.lovetitle;
            }

            this.overlay=false;
            this.overlayPIN=false;

            this.loading=false;
            if (typeof this.$redrawVueMasonry === 'function') {
        this.$redrawVueMasonry()
      }
          })
          .catch(err => {
            console.log(err.response);
          });
      },

      businessExplore()
      {
       this.$router.push({name:'businessDetails',params:{id: '86'}});
      },
      home()
      {

        //this.getBusiness();
        this.$router.push({name:'bDetails'});
        //this.$router.push({name:'coronasurvey'});
        this.activeBtn=0;
        //this.currentSection='overview';
      },
      corona()
      {
        //this.$router.push({name:'bDetails'});
        this.$router.push({name:'coronasurvey'});
        this.activeBtn=0;
        //this.currentSection='overview';
      },
      health()
      {
        //this.$router.push({name:'bDetails'});
        this.$router.push({name:'health'});
        this.activeBtn=0;
        //this.currentSection='overview';
      },
      love()
      {
          if(this.activeBtn!=3)
          {
              this.$router.push({name:'love'});

          }
          this.activeBtn=3;
          //this.currentSection='love';
      },
      food()
      {
          this.$router.push({name:'food'});

          this.activeBtn=4;



          //this.getBusiness();
      },
      event()
      {

        this.$router.push({name:'events'});


        this.activeBtn=1;
      },

      drink()
      {


        this.$router.push({name:'drink'});

        this.activeBtn=5;


                //this.getBusinessDrink();


      },
      retailitem()
      {
        this.$router.push({name:'retailitem'});

        this.activeBtn=6;

      },

      team()
      {
          //this.$router.push({name:'teams',params:{id:  this.business_id}});
          // this.currentSection='team';
          if(this.activeBtn!=2)
              {
                this.$router.push({name:'team'});

              } this.activeBtn=2;
      },
      juzzap()
      {
          this.$router.push({name:'tagsnew',params:{code:  'juzzap'}});
      },

    eventdetails()
    {
                this.$http
                .get(this.$apidomain+"eventDatanew/"+this.currentEvent)
                .then(res => {
                    this.currentEventdata = res.data.event;
                    this.activeBtn=1;
                    if (!this.$route.params.eventid)
                    {
                        this.$router.push({name:'eventdetail',params:{eventid:  this.currentEvent}});
                    }

                })
                .catch(err => {
                    console.log(err.response);
                });
               // this.$emit('eventclick',this.event_id);
    },
    fooditemdetails()
    {
                this.$http
                .get(this.$apidomain+"fooditemDatanew/"+this.currentfooditem+'/'+this.currentcourseid)
                .then(res => {
                    this.currentfooditemdata = res.data.item;
                    this.activeBtn=4;
                    if (!this.$route.params.fooditemid)
                    {
                        this.$router.push({name:'fooditemdetails',params:{fooditemid:  this.currentfooditem,courseid:this.currentcourseid}});
                    }

                })
                .catch(err => {
                    console.log(err.response);
                });
               // this.$emit('eventclick',this.event_id);
    },
    healthadvicedetail()
    {
              console.log('health');
                this.$http
                .get(this.$apidomain+"eventDatanew/"+this.currentEvent)
                .then(res => {
                    this.currentEventdata = res.data.event;
                    //this.activeBtn=1;

                    this.$router.push({name:'healthadvice'});


                })
                .catch(err => {
                    console.log(err.response);
                });
               // this.$emit('eventclick',this.event_id);
    },
    teamdetail()
        {
            this.$http

            .get( this.$apidomain+"employeeData/" + this.currentTeam)
            .then(res => {
            this.currentTeamdata =res.data.Employee;
            this.activeBtn=2;

            if (!this.$route.params.teamid)
                    {
                        this.$router.push({name:'teamdetail',params:{teamid:  this.currentTeam}});
                    }
            // this.bannerImg=this.businesses.teamimage;
            // if(this.bannerImg==null || this.bannerImg=='null')
            // {
            //     this.bannerImg=require('@/assets/overview-banner.jpg');
            // }

            //console.log(this.businesses);
            })
            .catch(err => {
            console.log(err.response);
            });
        },
    },


})
</script>
<style>
.mt-50
{
  margin-top:50px !important;
}
.v-item-group.v-bottom-navigation .v-btn {

	min-width: 1px !important;

}

.v-item-group.v-bottom-navigation .v-btn::before {

    background-color: transparent;

}
.mt-57-n{
    margin-top:-57px;
}
.v-item-group.v-bottom-navigation .v-btn .v-btn__content{
    opacity: 1 !important;
}
.hide{
    display: none;
}
.pulse
{
  transform: scale(1);
	animation: pulse 2s infinite;
}
@keyframes pulse {
	0% {
		transform: scale(0.9);

	}

	70% {
		transform: scale(1);

    }

	100% {
		transform: scale(0.9);

	}
}
.text-yellow
{
  color:#eeff41;
}
.v-application--is-ltr .v-list-group--no-action > .v-list-group__items > div > .v-list-item {
	padding-left: 30px;
}
</style>
